/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable no-unsafe-optional-chaining */
import {
  CURRENCIES,
  LANG_CODE,
  langList
} from '@constant/system';
import Hamburger from '@public/icon/menu-icon.svg';
import announcementApi from '@utils/api/announcements.api';
import useCommon from '@utils/hooks/common';
import useRequest from '@utils/hooks/useRequestCustom';
import {
  Button,
  Col,
  Drawer,
  Layout,
  Menu,
  MenuProps,
  Row,
  Select,
  Spin,
  Tabs
} from 'antd';
import { autorun } from 'mobx';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { JoinedRoomProps } from 'poker-interfaces/game-room/game-room-interface';
import { useEffect, useRef, useState } from 'react';
import footer from '../footerItems';
import menus from '../menuItems';
import UserProfile from '../user-profile';
import styles from './styles';
// import { useSDK } from '@metamask/sdk-react';
import AssetsRow from '@components/AssetsRow';
import {isMerchantGateway} from '@utils/gateway/merchant-gateway';
import BoxShadowButton from '@components/BoxShadowButton';
import CustomSelect from '@components/CustomSelect';
import PlayerAvatar from '@components/PlayerAvatar';
import classNames from 'classnames';

// import {useAccount} from 'wagmi';
import WalletConnectConfig from '@configs/WalletConnectConfig';
// import Setup2FAModalSheet from '../Setup2FAModalSheet';

import { disconnect } from '@wagmi/core';
// import LoginModalSheet from '../LoginModalSheet';
// import ProfileSettingModalSheet from '../ProfileSettingModalSheet';
// import EmailVerificationModalSheet from '../ModalSheets/VerifyEmail';
// import IdVerificationModalSheet from '../ModalSheets/VerifyId';
// import Disable2FAModalSheet from '../ModalSheets/Disable2FA';
import { GAME_MODE } from '@constant/game';

import { useDebugView } from '@utils/hooks/debug';
import useIsMobile from '@utils/hooks/useIsMobile';
import { clearLocalStorageExceptDontShowDisclaimerAgain } from '@utils/index';
import _ from 'lodash-es';
import dynamic from 'next/dynamic';
import { isTelegramMiniApp } from '..';
import TabBubbleSection from './TabBubbleSection';

const LoginModalSheet = dynamic(() => import('../LoginModalSheet'), {
  ssr: false,
});
const LuckyDrawModalSheet = dynamic(() => import('../ModalSheets/LuckyDraw'), {
  ssr: false,
});

const ProfileSettingModalSheet = dynamic(() => import('../ProfileSettingModalSheet'), {
  ssr: false,
});
const EmailVerificationModalSheet = dynamic(() => import('../ModalSheets/VerifyEmail'), {
  ssr: false,
});
const IdVerificationModalSheet = dynamic(() => import('../ModalSheets/VerifyId'), {
  ssr: false,
});
const Disable2FAModalSheet = dynamic(() => import('../ModalSheets/Disable2FA'), {
  ssr: false,
});
const Setup2FAModalSheet = dynamic(() => import('../Setup2FAModalSheet'), {
  ssr: false,
});
const PurchaseModalSheet = dynamic(() => import('@components/user-profile/PurchaseModalSheet'), {
  ssr: false,
});
const CustomPopup = dynamic(() => import('@components/CustomPopup'), {
  ssr: false,
});
const CustomDivider = dynamic(() => import('@components/CustomDivider'), {
  ssr: false,
});

const {Header} = Layout;
const {Option} = Select;
const {SubMenu, Item} = Menu;

export const termsAndConditions = [
  {
    title: 'terms_1_title',
    description: 'terms_1_content',
  },
  {
    title: 'terms_2_title',
    description: 'terms_2_content',
  },
  {
    title: 'terms_3_title',
    description: 'terms_3_content',
  },
  {
    title: 'terms_4_title',
    description: 'terms_4_content',
  },
  {
    title: 'terms_5_title',
    description: 'terms_5_content',
  },
  {
    title: 'terms_6_title',
    description: 'terms_6_content',
  },
  {
    title: 'terms_7_title',
    description: 'terms_7_content',
  },
  {
    title: 'terms_8_title',
    description: 'terms_8_content',
  },
];

const MobileHeader = () => {
  const {t, theme, classes, language, user, system} = useCommon({
    withStyles: styles,
    withTranslation: ['menu'],
    observers: ['user', 'language', 'system'],
  });

  const [visible, setVisible] = useState(false);
  const [isAnnouncementVisible, setIsAnnouncementVisible] = useState<boolean>(false);
  const [isTermAndConditionVisible, setIsTermAndConditionVisible] = useState<boolean>(false);
  const [joinedRooms, setJoinedRooms] = useState<Array<JoinedRoomProps>>([]);
  const [headerWidth, setHeaderWidth] = useState<string>(null); // in px
  const [modalSheetType, setModalSheetType] = useState<String>(system.modalSheetType);

  const router = useRouter();

  const isDebugView = useDebugView();

  const headerRef = useRef<HTMLElement>(null);

  const isDesktop = theme?.currentStyleFormat?.id === 'desktop';
  const isMobile = useIsMobile();

  const hideSideBar = () => {
    setVisible(false);
  };

  useEffect(() => {
    autorun(() => {
      if (user?.joinedRooms?.length > 0) {
        // console.log('user?.joinedRooms in MobileHeader', toJS(user?.joinedRooms));
        if (JSON.stringify(user?.joinedRooms) != JSON.stringify(joinedRooms)) {
          setJoinedRooms(user?.joinedRooms || []);
        }
      } else {
        setJoinedRooms([]);
      }

      if (system.modalSheetType !== modalSheetType) {
        setModalSheetType(system?.modalSheetType);
      }
    });
  }, []);

  // useEffect(() => {
  //   if (events.data.event === 'CONNECT_SUCCESS') {
  //     console.log('address', walletConnectAddress);
  //     loginWithWalletConnect();
  //   }
  // }, [events]);

  const {
    data: announcementList,
    loading: isAnnouncementLoading,
    runAsync: getAnnouncementList,
  } = useRequest(token => announcementApi.getAnnouncementList(user?.getPlayerToken()), {
    manual: true,
  });

  const onResize = _.debounce(() => {
    if (isDesktop && headerRef?.current?.parentElement) {
      const style = window.getComputedStyle(headerRef.current?.parentElement);
      const paddingX = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
      const width = headerRef.current?.parentElement.clientWidth - paddingX;

      setHeaderWidth(`${width}px`);
    } else {
      setHeaderWidth(null);
    }
  }, 100);

  useEffect(() => {
    onResize();

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [isDesktop, headerRef]);

  useEffect(() => {
    router.events.on('routeChangeComplete', hideSideBar);
    return () => {
      router.events.off('routeChangeComplete', hideSideBar);
    };
  }, []);

  const hasJoinedAnyRoom = !joinedRooms.every(code => !code);

  // const {currentLanguage} = language;

  const hiddenInPath = ['/email-verification', '/email-verify', '/user-profile', '/history'];

  const shouldHideAssets = (pathname: string) => {
    return hiddenInPath.includes(pathname);
  };

  const playerCountHiddenPath = ['/user-profile', '/history'];

  const shouldHidePlayerCount = (pathname: string) => {
    return playerCountHiddenPath.includes(pathname);
  };

  const onMenuClick: MenuProps['onClick'] = e => {
    if (e.key === '/game-recharge') {
      // console.log('onMenuClick - e', e);
      setVisible(false);
      system?.showModalSheet('depositWithdraw');
    } else if (e.key === '/game-recharge?type=lucky-draw') {
      setVisible(false);
      system?.showModalSheet('luckyDraw');
    } else {
      router.push(e.key);
    }
  };

  const getMenuItem = (mainPath, data) => {
    const {icon, label, path, needLogin = false, needFirstPartyGateway = false} = data;

    if (needLogin && !user?.isLogin()) {
      return null;
    }

    if (needFirstPartyGateway && user?.isThirdPartyGateway() && !isMerchantGateway()) {
      return null;
    }

    return (
      <Item className={classes.menuItem} key={`${mainPath}${path}`}>
        {/* <Link href={`${mainPath}${path}`}>
          <div className={classes.menuIcon}>{icon || null}</div>
          <div className={classes.menuText}>{t(label)}</div>
        </Link> */}
        <div className={classes.menuIcon}>{icon || null}</div>
        <div className={classes.menuText}>{t(label)}</div>
      </Item>
    );
  };

  const getQuickAccessItem = (domain, data) => {
    const {path, label} = data;
    return (
      <li key={`${domain}${path}`}>
        <Link href={`${domain}${path}`}>
          <a>{t(`menu:${label}`)}</a>
        </Link>
      </li>
    );
  };

  const getFooterItem = (domain, data, index) => {
    const {path, label, needFirstPartyGateway = false} = data;
    if (!user?.isLogin()) return null;
    if (needFirstPartyGateway && user?.isThirdPartyGateway() && !isMerchantGateway()) return null;

    return (
      <li key={`${domain}${path}`}>
        <Link href={`${domain}${path}`}>{t(`menu:${label}`)}</Link>
      </li>
    );
  };

  const renderList = () => {
    if (announcementList?.length === 0 || !announcementList)
      return <div style={{fontSize: 14}}>{t('no_news')}</div>;

    return (
      <Tabs
        // style={{height: '50vh'}}
        tabPosition="left"
        items={announcementList
          ?.filter(announcement => announcement?.active !== false)
          ?.sort(
            (announcementA, announcementB) => announcementA?.priority - announcementB?.priority
          )
          ?.map(announcement => {
            const {active, title, content, priority, from, to, id} = announcement;
            return {
              label: `${title}`,
              key: id,
              children: `${content}`,
            };
          })}
      />
    );
  };

  const handleLogout = async () => {
    user.updatePlayerToken('');

    // wallet connect sign out
    await disconnect(WalletConnectConfig);
    clearLocalStorageExceptDontShowDisclaimerAgain();
    router.push('/home');
    sessionStorage.removeItem('hasLuckyDrawReminderDisplayed');
  };

  const renderConnectButton = () => {
    if (user?.isThirdPartyGateway()) {
      return null;
    }

    if (!user?.isLogin()) {
      return (
        <Button className={classes.connectButton} onClick={() => system?.showModalSheet('login')}>
          <img
            srcSet="/icon/layout/wallet.svg"
            alt="wallet icon"
            width="25"
            style={{marginRight: 2.5}}
          />
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {t('menu:connect_login')}
          </span>
        </Button>
      );
    }

    return (
      <img
        onClick={() => system?.showModalSheet('depositWithdraw')}
        srcSet="/icon/layout/wallet.svg"
        alt="wallet icon"
        width="30"
        className={classes.walletIcon}
      />
    );
  };

  return (
    <>
      {!isTelegramMiniApp && !isMobile && (
        <>
          <Header
            style={headerWidth !== null ? {width: headerWidth} : {}}
            ref={headerRef}
            className={classNames(classes.header, {
              [classes.hidden]: isTelegramMiniApp,
            })}
          >
            <Row
              className={hasJoinedAnyRoom ? classes.buttonRowWithJoinRoom : classes.buttonRow}
              justify="space-between"
              align="bottom"
            >
              {hasJoinedAnyRoom ? (
                <Col className={classes.hamburgerAndLogoContainer} span={24}>
                  {isDesktop ? null : (
                    <Button
                      type="text"
                      className={classes.menuButton}
                      onClick={() => setVisible(true)}
                    >
                      <Hamburger className={classes.hamburger} />
                    </Button>
                  )}
                  <div
                    className={classNames(classes.multiTableButtonContainer, {
                      hidden: !user?.isLogin() && !isDebugView,
                    })}
                  >
                    <TabBubbleSection />
                  </div>
                  {renderConnectButton()}
                </Col>
              ) : (
                <>
                  <Col className={classes.hamburgerAndLogoContainer} span={12}>
                    {isDesktop ? null : (
                      <Button
                        type="text"
                        className={classes.menuButton}
                        onClick={() => setVisible(true)}
                      >
                        <Hamburger className={classes.hamburger} />
                      </Button>
                    )}
                    <Button onClick={() => router.push('/home')} style={{padding: 0}} type="text">
                      <img
                        src="/images-mobile/header-mobile/win4poker-horizontal.svg"
                        height={18}
                        alt="logo"
                      />
                    </Button>
                  </Col>

                  <Col className={classes.rightColumn} span={12}>
                    {renderConnectButton()}
                  </Col>
                </>
              )}
            </Row>
            <CustomDivider className={classes.assetDivider} />
            <AssetsRow
              isAssetsVisible={user?.isLogin() && !shouldHideAssets(router.pathname)}
              isPlayerCountVisible={!shouldHidePlayerCount(router.pathname)}
            />
          </Header>
          <Drawer
            rootClassName={classes.drawer}
            placement="left"
            onClose={() => setVisible(false)}
            open={visible}
            width="85%"
            styles={{
              content: {
                backgroundColor: '#222835',
              },
              header: {
                display: 'none',
              },
            }}
            closeIcon={<img src="/icon/cross.svg" alt="close icon" />}
          >
            <aside className={classes.asideContentContainer}>
              <section className={classes.upperPartSection}>
                <section className={classes.upperPartWrapper}>
                  <section className={classes.userProfileSection}>
                    {user?.isLogin() ? (
                      <UserProfile />
                    ) : (
                      <div>
                        <div
                          style={{display: 'flex', alignItems: 'center', marginBottom: 15, gap: 15}}
                        >
                          <PlayerAvatar style={{flexShrink: 0}} icon={null} iconWidthPx={80} />
                          <div style={{width: '100%'}}>
                            <BoxShadowButton
                              // * 190px is to accommodate for min 360px screen width
                              style={{height: 40, width: '100%', maxWidth: 190}}
                              onClick={() => {
                                setVisible(false);
                                system?.showModalSheet('login');
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  columnGap: 10,
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                <img src="/icon/home/wallet.svg" style={{width: 20}} />
                                <div style={{width: '100%'}}>{t('connect_login')}</div>
                              </div>
                            </BoxShadowButton>
                          </div>
                        </div>
                      </div>
                    )}
                  </section>
                  {user?.isLogin() ? (
                    <section className={classes.siderButtonRow}>
                      <BoxShadowButton
                        className={classes.siderButton}
                        onClick={() => {
                          router.push({
                            pathname: '/game-list/',
                            query: {
                              gameType: GAME_MODE.REGULAR,
                              currencyId: CURRENCIES.COIN,
                              isAllIn: false,
                            },
                          });
                        }}
                      >
                        <img style={{marginRight: 10}} src="/icon/menu/newGame.svg" />
                        <span>{t('new_game')}</span>
                      </BoxShadowButton>
                      {!user?.isThirdPartyGateway() && (
                        <BoxShadowButton
                          className={classes.siderButton}
                          onClick={() => {
                            router.push('/referral');
                          }}
                        >
                          <img style={{marginRight: 10}} src="/icon/menu/inviteFriends.svg" />
                          <span>{t('invite_friends')}</span>
                        </BoxShadowButton>
                      )}
                    </section>
                  ) : null}
                </section>
                <CustomDivider className={classes.divider} />
              </section>
              <section className={classes.navigationSection}>
                <nav>
                  <Menu
                    onClick={onMenuClick}
                    theme="dark"
                    defaultSelectedKeys={[`${router.asPath}`]}
                    className={classes.menuInDrawer}
                  >
                    {menus.map(menuItem => getMenuItem('', menuItem))}
                  </Menu>
                </nav>
              </section>
              <div className={classes.indentedSectionsContainer}>
                <CustomDivider className={classes.divider} />
                <section className={classes.languageSelectorSection}>
                  <CustomSelect
                    className={classes.languageSelector}
                    defaultValue={language?.currentLanguage || LANG_CODE.ZH_HK}
                    options={langList.map(lang => ({
                      label: (
                        <span style={{display: 'flex', alignItems: 'center'}}>
                          {
                            <img
                              className={classes.languageIcon}
                              src={lang.icon}
                              alt={lang.value}
                              width={15}
                              height={15}
                            />
                          }{' '}
                          {lang.label}
                        </span>
                      ),
                      value: lang.value,
                    }))}
                    onChange={val => {
                      language?.setLanguage(val);
                    }}
                    variant="borderless"
                  />
                </section>
                <section className={classes.footerSection}>
                  <footer>
                    <ul>
                      {footer.map((footerItem, index) => getFooterItem('', footerItem, index))}
                    </ul>
                    <div
                      className={classes.footerButton}
                      onClick={() => setIsTermAndConditionVisible(!isTermAndConditionVisible)}
                    >
                      {t(`tnc`)}
                    </div>
                    <div
                      className={classes.footerButton}
                      onClick={() => {
                        getAnnouncementList(user?.getPlayerToken());
                        setIsAnnouncementVisible(!isAnnouncementVisible);
                      }}
                    >
                      {t('announcement')}
                    </div>
                    {user?.isLogin() && !user?.isThirdPartyGateway() ? (
                      <div
                        className={classes.footerButton}
                        onClick={() => {
                          handleLogout();
                        }}
                      >
                        {t('logout')}
                      </div>
                    ) : null}
                  </footer>
                </section>
              </div>
            </aside>
          </Drawer>
        </>
      )}
      <CustomPopup
        // className={classes.announcementPopup}
        width={isDesktop ? '600px' : '300px'}
        open={isAnnouncementVisible}
        closable
        onCancel={() => {
          setIsAnnouncementVisible(false);
        }}
        title={t('announcement')}
      >
        {isAnnouncementLoading ? (
          <div className={classes.modalSpin}>
            <Spin />
          </div>
        ) : (
          renderList()
        )}
      </CustomPopup>
      <CustomPopup
        width={isDesktop ? '600px' : '85vw'}
        open={isTermAndConditionVisible}
        closable
        title={t('terms_and_conditions')}
        onCancel={() => {
          setIsTermAndConditionVisible(false);
        }}
      >
        <ol className={classes.modalBodyContent}>
          {termsAndConditions.map((item, index) => (
            <li key={index}>
              <div style={{fontWeight: 600}}>{t(item.title)}</div>
              <p>{t(item.description)}</p>
            </li>
          ))}
        </ol>
      </CustomPopup>
      <Setup2FAModalSheet
        isModalSheetOpen={
          modalSheetType === 'setup2FA' || modalSheetType === 'setup2FAInVerification'
        }
        onModalSheetClose={() => system?.dismissModalSheet()}
      />
      <LoginModalSheet
        // connectMetaMask={connect}
        openWalletConnectModal={() => {
          // if (isConnected) {
          //   openWalletConnectModal({view: 'Account'});
          // } else {
          //   openWalletConnectModal({view: 'Connect'});
          // }
        }}
        isModalSheetOpen={!user?.isLogin() && modalSheetType === 'login'}
        onModalSheetClose={() => {
          system?.dismissModalSheet();
        }}
      />
      <EmailVerificationModalSheet
        isModalSheetOpen={modalSheetType === 'verifyEmail'}
        onModalSheetClose={() => system?.dismissModalSheet()}
      />
      <IdVerificationModalSheet
        isModalSheetOpen={modalSheetType === 'verifyId'}
        onModalSheetClose={() => system?.dismissModalSheet()}
      />
      <ProfileSettingModalSheet
        isModalSheetOpen={modalSheetType === 'profileSettings'}
        onModalSheetClose={() => system?.dismissModalSheet()}
      />
      <Disable2FAModalSheet
        isModalSheetOpen={modalSheetType === 'disable2FA'}
        onModalSheetClose={() => system?.dismissModalSheet()}
      />
      <PurchaseModalSheet
        isModalSheetOpen={modalSheetType === 'purchase'}
        onModalSheetClose={() => system?.dismissModalSheet()}
      />
      <LuckyDrawModalSheet
        isModalSheetOpen={modalSheetType === 'luckyDraw'}
        onModalSheetClose={() => system?.dismissModalSheet()}
      />
    </>
  );
};

export default MobileHeader;
